import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

export default class extends Controller {
  static values = {
    stringTooltipContent: String,
    truncatableElements: Boolean,
    tippyOptions: Object
  }
  static targets = ['htmlTooltipContent', 'turboContent']

  initialize() {
    if (this.hasTruncatableElementsValue && !this.isTruncated()) {
      return
    }

    this.generateTooltip()
  }

  isTruncated() {
    return this.element.scrollWidth > this.element.offsetWidth
  }

  generateTooltip() {
    let that = this
    tippy(this.element, {
      content: this.tooltipContent(),
      theme: 'aktio-tooltip-v2',
      allowHTML: this.hasHtmlTooltipContentTarget,
      delay: [350, 0],
      duration: [100, 0],
      maxWidth: 240,
      interactive: true,
      appendTo: () => document.body,
      onTrigger(instance) {
        if (!that.hasTurboContentTarget) {
          return
        }
        let turboFrame = instance.props.content
        turboFrame.loading = 'eager'
      },
      ...this.tippyOptionsValue
    })
  }

  tooltipContent() {
    if (this.hasHtmlTooltipContentTarget) {
      return this.htmlTooltipContentTarget.innerHTML
    } else if (this.hasTurboContentTarget) {
      let turboFrame = this.turboContentTarget.children[0]
      return turboFrame
    } else if (this.hasTruncatableElementsValue) {
      return this.element.textContent
    } else {
      return this.stringTooltipContentValue
    }
  }
}
